// extracted by mini-css-extract-plugin
export default {"SignInButton":"azure_SignInButton__UhRE1","SignInButtonText":"azure_SignInButtonText__bGvIy","SaasOrgSelect":"azure_SaasOrgSelect__BWkHn"};